import React from 'react'
import errorPage from "../Assets/ErrorPage.svg"
import { useNavigate } from 'react-router-dom'
export default function Error() {
  const homeNavigate = useNavigate();
  return (
    <>
   <div className="errorPageSection">
   <figure>
        <img src={errorPage} alt="img" />
      </figure>
      <button onClick={() => {homeNavigate("/")}}>Back to Home</button>
   </div>
    </>
  )
}
